<template>
  <a-spin :spinning="loading">
    <div class="spin-content">
      <a-dropdown :trigger="['contextmenu']">
        <a-popover title="Notas" :visible="popVisible">
          <template slot="content">
            <p v-html="notas"></p>
          </template>

          <span class="ctinput ant-input-affix-wrapper ant-input-affix-wrapper-sm">
          <a-badge :dot="festivo" v-if="mostrarDomingos === 'SI'">
            <a-badge :dot="domingo">
              <input type="text"
                     size="small"
                     class="ant-input ant-input-sm ctinput"
                     :style="colorBorderInput"
                     :readonly="readOnly"
                     v-model="inputValue"
                     v-on:input="input"
                     v-on:keydown="keyDownHandler"
                     v-on:keyup="keyUpHandler"
                     v-on:blur="focusLost"
                     @mouseover="mouseOver = true"
                     @mouseleave="mouseOver = false"/>
            </a-badge>
          </a-badge>
            <a-badge :dot="festivo" v-else>
              <input type="text"
                     size="small"
                     class="ant-input ant-input-sm ctinput"
                     :style="colorBorderInput"
                     :readonly="readOnly"
                     v-model="inputValue"
                     v-on:input="input"
                     v-on:keydown="keyDownHandler"
                     v-on:keyup="keyUpHandler"
                     v-on:blur="focusLost"
                     @mouseover="mouseOver = true"
                     @mouseleave="mouseOver = false"/>
          </a-badge>
          </span>
        </a-popover>
        <a-menu slot="overlay">
          <a-menu-item key="1" :disabled="readOnly || !editable" @click="eliminar">
            <a-icon type="delete" style="color:red"/>
            Eliminar
          </a-menu-item>
        </a-menu>
      </a-dropdown>
    </div>
  </a-spin>
</template>
<script>
  import JsUtils from '@/util/JsUtils'

  export default {
    props: ['value', 'readOnly', 'loading', 'editable', 'valoresPermitidos', 'notas', 'festivo', 'color', 'domingo'],
    data () {
      return {
        colorBorderInput: `border-color:${this.color ? this.color : 'none'};`,
        inputValue: null,
        oldInputValue: null,
        lastInput: null,
        mouseOver: false,
        mostrarDomingos: this.$getConfigValue('MOSTRAR_DOMINGOS_PANTALLA_TURNOS', null)
      }
    },
    mounted () {
      this.oldInputValue = this.inputValue = this.value
    },
    methods: {
      input (e) {
        this.inputValue = (this.inputValue + '').toUpperCase()
      },
      keyDownHandler (e) {
        // SHIFT Y TAB
        /* HAY USUARIOS QUE PRESIONAN EL TAB MUY RAPIDO Y EL SISTEMA NO DETECTA EL KEY */
        if (e.keyCode === 16 || e.keyCode === 9) {
          return
        }

        if (this.kd || !this.editable) {
          e.preventDefault()
          return
        }
        this.kd = true
        if (JsUtils.isEmpty(this.lastInput)) {
          this.lastInput = moment()
        } else {
          let diff = moment().diff(this.lastInput)
          if (diff < 10) {
            e.preventDefault()
            return
          }
          this.lastInput = moment()
        }
        if (this.valoresPermitidos.includes(this.inputValue)) {
          this.oldInputValue = this.inputValue
        }
      },
      keyUpHandler (e) {
        // SHIFT Y TAB
        if (e.keyCode === 16 || e.keyCode === 9) {
          return
        }
        e.preventDefault()
        if (!this.isInputValid()) {
          this.inputValue = this.oldInputValue
        } else {
          /* emite el cambio */
          if (this.valoresPermitidos.includes(this.inputValue) && this.inputValue !== this.value) {
            this.$emit('input', this.inputValue)
          }
        }
        this.kd = false
      },
      isInputValid () {
        for (let op of this.valoresPermitidos) {
          if (op.startsWith(this.inputValue)) {
            return true
          }
        }
        return false
      },
      focusLost (e) {
        if (!this.valoresPermitidos.includes(this.inputValue)) {
          this.inputValue = this.oldInputValue
        }
      },
      eliminar () {
        this.$emit('delete')
      }
    },
    watch: {
      value () {
        this.inputValue = (this.value + '').toUpperCase()
        this.oldInputValue = this.inputValue
      }
    },
    computed: {
      popVisible () {
        return !JsUtils.isEmpty(this.notas) && this.mouseOver
      }
    }
  }
</script>
<style>
  .ctinput > input {
    text-transform: uppercase;
    padding: 1px;
    width: 26px !important;
  }

  .ctinput.ant-input-affix-wrapper .ant-input:not(:last-child) {
    padding: 1px;
  }
</style>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/ShiftsManagement/ShiftsManagementInput.vue